import { Callout } from "@blueprintjs/core";

import { Box } from "@/components/layout/flexbox";
import { isOverlapExistInMeetingList } from "@/components/pieces/coaching/meetings/utils";
import { FullMeeting } from "@/types/meetings";
import { CoachingCurrentUser, CoachingCustomer } from "@/types/users";

interface OverlapMeetingBannerProps {
  meetings: FullMeeting[];
  user: CoachingCurrentUser | CoachingCustomer;
}

export function OverlapMeetingBanner({
  meetings,
  user,
}: OverlapMeetingBannerProps) {
  if (
    !isOverlapExistInMeetingList({
      meetingList: meetings.filter((meeting) => !meeting.canceledAt),
      user,
    })
  ) {
    return null;
  }

  return (
    <Callout
      intent="warning"
      style={{ fontSize: 15, marginTop: 16, marginBottom: 16 }}
    >
      <Box>Currently, you have meetings that overlap with each other.</Box>
      <Box>
        The overlapping meetings are grouped by color below. Please reschedule
        one of those meetings!
      </Box>
    </Callout>
  );
}
